/** company — EN source (183 keys). */
export const company = {
  company_intro_description:
    "As a hosting venue, Linqx can help you bring friends together and manage your events.",
  company_intro_sign_in_email: "Sign in with Email",
  company_intro_sign_in_code: "Sign in with Code",
  company_intro_trouble: "Trouble signing in?",
  company_title_header: "Business Name",
  company_title_placeholder: "Add Event Name",
  company_title_hint:
    "This is how it will appear in Linqx and you will not be able to change it.",
  company_ein_header: "Business EIN",
  company_ein_hint: "Enter your Employer Identification Number (EIN).",
  company_admin_header: "Admin Settings",
  company_admin_subtitle: "I am",
  company_admin_owner: "Owner",
  company_admin_admin: "Admin",
  company_admin_other: "Other",
  company_contact_header: "Contact Info",
  company_contact_email: "Email",
  company_contact_phone: "Phone",
  company_type_header: "Business Type",
  company_type_hint: "Select as many that apply",
  company_welcome_rules_title: "Photos follow these House Rules:",
  company_welcome_rule_1_title: "Manage Events",
  company_welcome_rule_1_desc:
    "View, edit and manage all events all from mobile or web.",
  company_welcome_rule_2_title: "Guests / Reservations",
  company_welcome_rule_2_desc:
    "See full lists of people invited and accepted to your selected event.",
  company_welcome_rule_3_title: "QR Confirmations",
  company_welcome_rule_3_desc:
    "Confirm your reservations all in our app digitally.",
  company_welcome_rule_4_title: "Be proactive",
  company_welcome_rule_4_desc: "Always report bad behavior.",
  company_welcome_agree: "I Agree",
  company_complete_message: "Your business has been registered successfully!",
  company_complete_start_tutorial: "Start Tutorial",
  company_complete_skip: "Skip",
  company_dashboard_title: "Dashboard",
  company_dashboard_employees: "Employees",
  company_dashboard_employees_count: "{count} team members",
  company_dashboard_add_employee: "Add Employee",
  company_dashboard_manage_team: "Manage Team",
  company_dashboard_view_all: "View All",
  company_employees_title: "Team Members",
  company_employees_empty: "No team members yet",
  company_employees_empty_hint: "Add employees to help manage your business",
  company_employees_search: "Search employees...",
  company_employees_add_first: "Add Your First Employee",
  company_employee_title: "Employee Details",
  company_employee_role: "Role",
  company_employee_contact: "Contact Information",
  company_employee_email: "Email",
  company_employee_phone: "Phone",
  company_employee_status: "Status",
  company_employee_update_role: "Update Role",
  company_employee_update_contact: "Update Contact",
  company_employee_remove: "Remove Employee",
  company_employee_remove_confirm:
    "Are you sure you want to remove this employee?",
  company_add_employee_title: "Add Team Member",
  company_add_employee_user_id: "User ID",
  company_add_employee_user_id_placeholder: "Enter user ID",
  company_add_employee_email: "Email Address",
  company_add_employee_email_placeholder: "Enter email address",
  company_add_employee_phone: "Phone Number",
  company_add_employee_phone_placeholder: "Enter phone number",
  company_add_employee_role: "Select Role",
  company_add_employee_role_hint: "Choose a role for this team member",
  company_add_employee_success: "Employee added successfully",
  company_add_employee_button: "Add Employee",
  company_role_owner: "Owner",
  company_role_admin: "Admin",
  company_role_moderator: "Moderator",
  company_role_staff: "Staff",
  company_status_active: "Active",
  company_status_inactive: "Inactive",
  company_status_suspended: "Suspended",
  company_status_resigned: "Resigned",
  business_title: "Linqx Business",
  business_new_company: "New",
  business_no_companies: "No companies yet",
  business_no_companies_description:
    "Create your first company to start managing your business on Linqx.",
  business_create_company: "Create Company",
  business_team: "Team",
  business_add_member: "Add member",
  business_no_team_members: "No team members",
  business_no_team_members_description:
    "Add team members to help manage your business.",
  business_members_count: "{count} member(s)",
  business_information: "Information",
  business_team_management: "Team Management",
  business_name: "Name",
  business_description: "Description",
  business_basic: "BASIC",
  business_members: "MEMBERS",
  business_events_section: "EVENTS",
  business_events: "Events",
  business_status: "Status",
  business_created: "Created",
  business_draft: "Draft",
  business_company_not_found: "Company not found",
  business_business_name_label: "Business Name",
  business_business_name_placeholder: "Enter your business name",
  business_business_name_appears:
    "This is how your business will appear on Linqx.",
  business_ein_label: "EIN",
  business_ein_placeholder: "XX-XXXXXXX",
  business_ein_error_numeric:
    "EIN must contain numbers only (digits and an optional dash).",
  business_ein_error_length: "EIN must be exactly 9 digits (XX-XXXXXXX).",
  business_save_failed: "Couldn't save. Please try again.",
  business_ein_verification_description:
    "Enter your EIN for business verification.",
  business_role_select_description: "Select your role in this business.",
  business_contact_description: "How can customers reach your business?",
  business_email_label: "Business Email",
  business_contact_email_invalid: "Please enter a valid email address.",
  business_email_placeholder: "hello@yourbusiness.com",
  business_phone_label: "Phone Number",
  business_phone_placeholder: "+1 (555) 000-0000",
  business_type_select_description:
    "Select categories that describe your business.",
  business_welcome_review_description:
    "Please review and accept our business guidelines.",
  business_welcome_rule_1:
    "Keep your business information accurate and up to date",
  business_welcome_rule_2: "Treat all team members and customers with respect",
  business_welcome_rule_3: "Honor your event commitments and ticket sales",
  business_welcome_rule_4: "Follow Linqx community guidelines at all times",
  business_accept_continue: "Accept & Continue",
  business_accepting: "Accepting...",
  business_complete_description:
    "Your business has been created. You can now manage your team and start growing on Linqx.",
  business_creating: "Creating...",
  business_verifying: "Verifying...",
  business_saving: "Saving...",
  business_sending: "Sending...",
  business_onboarding_name_title: "Name your business",
  business_onboarding_ein_title: "Employer ID Number",
  business_onboarding_skip_ein: "I don't have an EIN",
  business_onboarding_role_title: "Your role",
  business_onboarding_contact_title: "Contact Information",
  business_onboarding_type_title: "Business Type",
  business_onboarding_welcome_title: "Almost there!",
  business_onboarding_complete_title: "You're all set!",
  business_onboarding_step_of: "Step {current} of {total}",
  business_onboarding_selected_count: "Continue ({count} selected)",
  business_role_owner: "Owner",
  business_role_admin: "Admin",
  business_role_moderator: "Moderator",
  business_role_staff: "Staff",
  business_role_owner_desc: "Full control over the business",
  business_role_admin_desc: "Can manage team members and company settings",
  business_role_moderator_desc: "Can moderate content and manage reports",
  business_role_staff_desc: "Basic team member access",
  business_role_admin_onboarding_desc: "Manage team and settings",
  business_role_moderator_onboarding_desc: "Limited management access",
  business_search_members: "Search members...",
  business_search_users: "Search users...",
  business_pending: "Pending",
  business_invite_send: "Send Invitation",
  business_invite_add: "Add to Team",
  business_invite_pending_description:
    "No account found for this email. A pending invitation will be created — they'll be added automatically when they sign up.",
  business_invite_direct_description: "Will be added immediately",
  business_dismiss: "Dismiss",
  business_edit_role: "Edit role",
  business_save: "Save",
  business_continue: "Continue",
  business_go_to_dashboard: "Go to Dashboard",
  business_add_role: "Add role",
  business_edit: "Edit",
  business_appoint_member: "You are about to appoint {name} as a member",
  business_current_role: "Current role: {role}",
  business_email_address_label: "Email address",
  business_email_address_placeholder: "Enter email address...",
  business_already_member: "This person is already a member of this company.",
  business_existing_users: "Existing users",
  business_role_label: "Role",
  business_business_type_label: "Business Type",
  business_business_name_input_placeholder: "Business name",
  business_business_description_placeholder:
    "Tell people about your business...",
  // LIN-145 — new vs existing business on the onboarding wizard
  business_checking: "Checking...",
  business_title_too_short: "Business name must be at least 2 characters.",
  business_title_already_member:
    "You're already part of this business. Open it from your business list.",
  business_title_not_joinable:
    "A business with this name already exists but can't be joined here. Ask its owner to invite you.",
  business_title_exists_retry:
    "A business with this name already exists. Tap Continue to join it.",
  business_too_many_attempts:
    "Too many attempts. Please wait a few minutes and try again.",
  business_join_ein_title: "Join {title}",
  business_join_ein_description:
    "{title} is already on Linqx. Enter its EIN to confirm you're part of this business.",
  business_join_ein_mismatch:
    "This EIN doesn't match the business. Check it and try again.",
  business_join_already_member:
    "You're already a member of this business. Open it from your business list.",
  business_join_failed: "Couldn't verify the EIN. Please try again.",
  business_role_new_org_note:
    "This is a new organization. Even if you are not the owner, you can change this later.",
  business_role_existing_org_note:
    "{title} already has an Owner. Choose your role on the team.",
  business_type_set_by_owner: "Business type is set by the business's Owner.",
  business_type_none_set: "The Owner hasn't set a business type yet.",
  business_join_complete_description:
    "You've joined {title}. You can open it anytime from your business list.",
};
